<template>
  <div class="digest mt-16 mb-16 pl-8 pr-4">
    <div class="flex items-center justify-evenly">
      <div class="md:max-w-lg pt-8 pr-5">
        <h2 class="text-left uppercase text-3xl">дайджест двух столиц</h2>
        <p class="text-base pt-5">
          <span class="text-white">Ваш персональный гид </span>по Москве и Санкт-Петербургу — всё самое интересное
          лаконично и со вкусом.
        </p>
        <a
          href="https://t.me/+R8Ayq8poZ0tlY2Ni"
          class="py-4 mt-5 max-w-sm text-black bg-white text-center md:block hidden"
          >Подписаться</a
        >
      </div>
      <div>
        <img src="../assets/images/poster.png" alt="Digest" class="h-auto -mt-20 md:-mt-16 mx-auto" />
      </div>
    </div>
    <a href="https://t.me/+R8Ayq8poZ0tlY2Ni" class="py-4 mt-5 text-black bg-white text-center block md:hidden"
      >Подписаться</a
    >
  </div>
</template>
<style scoped>
.digest {
  background: linear-gradient(180deg, #4b0000 0%, #111111 100%);
}
</style>
